import { create } from 'zustand';
import { refreshTokenDev, refreshTokenProd } from '../axios/login/login.api';
import { jwtDecode } from 'jwt-decode';

export const useAuthStore = create((set) => ({
  id: 0,
  accessToken: '',
  refreshToken: '',
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  features: [],
  currentPlan: '',
  detailsProvided: false,
  isInitializing: true,

  businessId: localStorage.getItem('businessId') ? localStorage.getItem('businessId') : null,
  locationId: localStorage.getItem('locationId') ? localStorage.getItem('locationId') : null,
  appTour: false,
  wizardInProgress: false,
  wizardLoader: false,
  setUpwizardLoader: () =>
    set((state) => {
      return {
        ...state,
        wizardLoader: !state.wizardLoader
      };
    }),
  setWizardInProgress: (val) =>
    set((state) => ({
      ...state,
      wizardInProgress: val
    })),
  appTourToggle: () =>
    set((state) => {
      return {
        ...state,
        appTour: !state.appTour
      };
    }),
  appTourOn: () =>
    set((state) => {
      return {
        ...state,
        appTour: true
      };
    }),
  appTourOff: () =>
    set((state) => {
      return {
        ...state,
        appTour: false
      };
    }),
  setAccessToken: (accessToken) =>
    set((state) => {
      const {
        id,
        firstName,
        lastName,
        email,
        role,
        locationId,
        businessId,
        features,
        currentPlan
      } = jwtDecode(accessToken);
      return {
        ...state,
        accessToken,
        role,
        id,
        firstName,
        lastName,
        email,
        features,
        currentPlan,
        businessId: localStorage.getItem('businessId')
          ? parseInt(localStorage.getItem('businessId'))
          : businessId,
        locationId: localStorage.getItem('locationId')
          ? parseInt(localStorage.getItem('locationId'))
          : locationId
      };
    }),
  setRefreshToken: (refreshToken) =>
    set((state) => {
      return {
        ...state,
        refreshToken
      };
    }),
  refreshAllTheToken: async () => {
    const accessToken =
      import.meta.env.VITE_APP_ENV === 'dev' ? await refreshTokenDev() : await refreshTokenProd();
    if (!accessToken) {
      set({
        accessToken: null,
        role: null,
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        locationId: localStorage.getItem('locationId') || null,
        isInitializing: false
      });
      return;
    }
    const { id, firstName, lastName, email, role, locationId } = jwtDecode(accessToken);
    set({
      accessToken,
      role,
      id,
      firstName,
      lastName,
      email,
      locationId: localStorage.getItem('locationId') || locationId,
      isInitializing: false
    });
  },
  setLocationId: (locationId) =>
    set((state) => {
      return {
        ...state,
        locationId: locationId
      };
    }),
  setBusinessId: (businessId) =>
    set((state) => {
      return {
        ...state,
        businessId: businessId
      };
    }),
  updateUserData: (body) =>
    set((state) => {
      return {
        ...state,
        firstName: body.firstName,
        lastName: body.lastName
      };
    }),
  setDetailsProvided: (val) =>
    set((state) => ({
      ...state,
      detailsProvided: val
    }))
}));
